<template>
  <basic-dialog
    :visible="visible"
    :title="titleName"
    :width="900"
    :update-vis="updateVis"
    :handle-close="handleClose"
    :handle-closed="handleClosed"
    :handle-ok="handleOk"
    :isShowFooterAll="false"
    class="changeHeight"
  >
    <el-form
      ref="form"
      size="small"
      label-position="right"
      label-width="128px"
      :model="dto"
      :rules="rules"
      node-key="id"
      @submit.native.prevent
      class="parent"
      :disabled="action=='view'"
    >
      <div class="entity-dlg__block-bd">
        <div class="top">
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item :label="$t('language.5o6uj7uysxs0')" prop="roleCode">
                <el-input :disabled="action=='edit'" v-model.trim="dto.roleCode" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('language.5o6uj7uysto0')" prop="roleName">
                <el-input v-model.trim="dto.roleName" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('language.5o6otz4p1w00')" prop="remark">
                <el-input v-model="dto.remark" />
              </el-form-item>
            </el-col>
            <!--菜单角色敏感字段-->
          
            <el-col :span="12">
              <el-form-item   v-if="this.showSensitive" :label="$t('language.5o6uj7uyt780')" prop="sensitiveMark" required: true>             
                <el-select :disabled="action=='edit'" v-model="dto.sensitiveMark" >
                    <el-option :label="$t('language.5o6uj7uyta00')" :value="0" />
                    <el-option :label="$t('language.5o6uj7uytcs0')" :value="1" />
                </el-select>
              </el-form-item>
            </el-col>
             <!-- <el-col :span="12">
              <el-form-item  v-if="this.showFlowID" >
                   <div slot="label">
                  审批流ID
                  <el-tooltip class="item" effect="dark" placement="top">
                    <div slot="content">
                     在审批平台配置审批流后即可获取审批ID。<a
                        href="http://lcp.jdwl.com/#/docSoftwareSystem/24/52741"
                        style="color: #2e8ff4"
                        >查看操作说明</a
                      >
                    </div>
                    <i class="el-icon-question"></i>
                  </el-tooltip>
                </div>
                <el-input v-model.trim="dto.flowId" />
              </el-form-item>
            </el-col> -->
            <!-- <el-col :span="12">
              <el-form-item  v-if="this.showFlowID" label="是否可申请"  prop="isApply">
                   
               <el-select  v-model="dto.isApply" >
                    <el-option label="是" :value="0" />
                    <el-option label="否" :value="1" />
                </el-select>
              </el-form-item>
            </el-col> -->
                <el-col :span="12">
              <el-form-item  v-if="this.showFlowID" >
                   <div slot="label">
                  {{$t('language.5o6vg67fmbw0')}}
                  <el-tooltip class="item" effect="dark" placement="top">
                    <div slot="content">
                     {{$t('language.5o6vg67fmes0')}}
                    </div>
                    <i class="el-icon-question"></i>
                  </el-tooltip>
                </div>
                <el-input v-model.trim="dto.illustration" />
              </el-form-item>
            </el-col>
              <el-col :span="12" :offset="1" v-for="item in my.diaExtLists" :key="item.key">
                  <el-form-item :label="item.name" :prop="item.key" :rules="item.rules">
                      <el-input v-if="item.type === 'input'" v-model.trim="dto[item.key]" :placeholder="item.placeholder" clearable />
                      <el-select v-else-if="item.type === 'select'" v-model.trim="dto[item.key]" :placeholder="item.placeholder" clearable filterable>
                          <el-option v-for="subItem of item.options" :key="subItem.code" :label="subItem.label" :value="subItem.value" />
                      </el-select>
                  </el-form-item>
              </el-col>
          </el-row>

        </div>
        <u-table
          use-virtual
          border
          class="umy-table"
          ref="umyTable"
          size="mini"
          style="width: 100%; margin-bottom: 8px;"
          row-id="id"
          row-key="id"
          :show-body-overflow="true"
          :show-header-overflow="true"
          :big-data-checkbox="true"
          :height="400"
          :row-height="40"
          :tree-config="treeConfig"
          :record-table-select="true"
          @select="select"
          @select-all="selectAll"
          @toggle-tree-expand="toggleTreeExpand"
        >
          <u-table-column type="selection" width="40"></u-table-column>
          <u-table-column
            v-for="(item, index) in tableList"
            :key="index"
            :tree-node="index===0"
            :prop="item.prop"
            :label="item.label"
            :width="item.width"
          >
            <template slot-scope="{row}">
              <template v-if="item.prop==='resourceType'">
                <span :class="judgeResourceTypeClassName(row[item.prop])">
                  {{judgeResourceTypeText(row[item.prop])}}
                </span>
              </template>
              <template v-else-if="item.prop==='sensitiveMark'">
                <span :style="row[item.prop]===1?'color: #F56C6C':null">
                  {{row[item.prop]===1?`${$t('language.5o6uj7uytcs0')}`:`${$t('language.5o6uj7uyta00')}`}}
                </span>
              </template>
              <template v-else>
                <span>
                  {{row[item.prop]}}
                </span>
              </template>
            </template>
          </u-table-column>
        </u-table>
      </div>
    </el-form>
    <div class="footer" v-if="action!='view'">
      <el-button @click="handleClose" size="mini">{{$t('language.5o6u3frcn8k0')}}</el-button>
      <el-button :loading="submitLoading" @click="handelClick" size="mini" type="primary">{{this.action=='add'?$t('language.5o6vkto5xjo0'):$t('language.5o6u3frcn9k0')}}</el-button>
    </div>
    <div class="footer" v-else>
      <el-button @click="handleClose" size="mini">{{$t('language.5o6uut7rgac0')}}</el-button>
    </div>
  </basic-dialog>
</template>

<script>
import EntityDialog from "@/mixins/entityDialog";
import { mapState } from "vuex";
import ExactList from "@/mixins/exactList";

export default {
  mixins: [EntityDialog, ExactList],
  props: {
    action: {
      type: String,
      default: "add",
    },
    state: {
      type: Object,
      default: {},
    },
    queryList: {
      type: Function,
      default: () => {},
    },
    roleListId: {
      type: Number,
      default: 0,
    },
    showSensitive: {
      type: Boolean,
      default: false,
    },
    showFlowID: {
      type: Boolean,
      default: false,
    },
    ids: {
      type: Array,
      default() {
        return [];
      },
    },
    obj: {
      type: Object,
      default: {},
    },
    changeids: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      submitLoading: false,
      warningMessageVisible: false,
      checkIs: true,
      titleName: "",
      rules: {
        // isApply: [
        //   { required: true, message: "是否可申请不能为空", trigger: "blur" },
        // ],
        roleName: [
          { required: true, message: this.$t('language.5o6vg67fmm40'), trigger: "blur" },
          // {
          //   pattern: CNST.REG_EXP.NORMAL_ROLE,
          //   message: "角色名称不能输入特殊字符",
          // },
          { max: 80, message: this.$t('language.5o6vg67fmog0') },
        ],
        roleCode: [
          { required: true, message: this.$t('language.5o6vg67fneo0'), trigger: "blur" },
          {
            pattern: CNST.REG_EXP.NORMAL_ROLE,
            message: this.$t('language.5o6vg67fnms0'),
          },
          { max: 80, message: this.$t('language.5o6vg67fnqk0') },
        ],
        remark: [
          { max: 120, message: this.$t('language.5o6vg67fntc0') },
        ],
        sensitiveMark: [
          { required: true, message: this.$t('language.5o6vg67foac0'), trigger: "blur" },
        ],
      },
      selectionList: [],
      treeConfig: {
        children: "children",
        iconClose: "el-icon-arrow-right",
        iconOpen: "el-icon-arrow-down",
        // expandRowKeys: this.ids,
        expandAll: true,
      },
      tableList: [
        { prop: "resourceName", label: this.$t('language.5o6vg67foic0') },
        { prop: "resourceCode", label: this.$t('language.5o6vg67folw0') },
        {
          prop: "resourceType",
          label: this.$t('language.5o6vg67foo80'),
          width: "110",
        },
        {
          prop: "sensitiveMark",
          label: this.$t('language.5o6vg67foqc0'),
          width: "155",
        },
      ],
      resourceTypeClassNameMap: {
        0: "cell-menu-word-style cell-common-word",
        1: "cell-button-word-style cell-common-word",
        2: "cell-others-word-style cell-common-word",
      },
      defaultProps: {
        children: "children",
        label: "label",
      },
    };
  },
  computed: {
    ...mapState("rolePermissions", ["query"]),
    ...mapState("app", ["tenementInfoObj"]),
    my() {
      console.log("this.state", this.state);
      return this.state;
    },
  },
  watch: {
    visible(newValue) {
      if (newValue) {
        this.$nextTick(async () => {
          // 加载虚拟表格数据
          await this.$refs.umyTable.reloadData(this.state.listTree || []);
          // 根据ids勾选虚拟表格
          if (this.action === "add") {
            this.$refs.umyTable.partRowSelections([], true);
          } else {
            if (this.ids && this.ids.length > 0) {
              const rows = this.$refs.umyTable.getUTreeData().filter((item) => {
                return this.ids.includes(item.id);
              });
              this.$refs.umyTable.partRowSelections(rows, true);
            }
          }
          this.selectionList = this.$refs.umyTable.getCheckboxRecords();
        });
      } else {
        this.selectionList = [];
      }
    },
    "state.listTree": {
      deep: true,
      handler(newValue) {
        console.log("state.listTree", newValue);
      },
    },
    immediate: true,
    action(n, l) {
      switch (this.action) {
        case "add":
          this.titleName = this.buttonData("tjcdjs").name;

          // this.titleName = "添加菜单角色";
          break;
        case "edit":
          // this.titleName = "编辑菜单角色";
          this.titleName = this.buttonData("bjcdjs").name;
          this.$forceUpdate();
          break;
        case "view":
          // this.titleName = "菜单角色详情";
          this.titleName = this.buttonData("cdjsxq").name;
          break;
      }
    },
    tenementInfoObj: {
      deep: true,
      immediate: false,
      handler: function (newVal) {
        this.queryList();
      },
    },
    obj(n, o) {
      if (this.action !== "add") {
        var obj2 = _.cloneDeep(this.obj);
        //修改

        console.log(obj2);
        this.dto.roleName = obj2.roleName;
        this.dto.roleCode = obj2.roleCode;
        this.dto.remark = obj2.remark;
        this.dto.flowId = obj2.flowId;
        this.dto.ext1 = obj2.ext1;
        this.dto.ext2 = obj2.ext2;
        this.dto.ext3 = obj2.ext3;
        this.dto.ext4 = obj2.ext4;
        this.dto.ext5 = obj2.ext5;
        this.dto.ext6 = obj2.ext6;
        this.dto.ext7 = obj2.ext7;
        this.dto.ext8 = obj2.ext8;
        this.dto.ext9 = obj2.ext9;
        this.dto.ext10 = obj2.ext10;
        if (obj2.sensitiveMark === null) {
          this.dto.sensitiveMark = 0;
        } else {
          this.dto.sensitiveMark = obj2.sensitiveMark;
        }
        this.dto.isApply = obj2.isApply;
        this.dto.illustration = obj2.illustration;
      } else if (this.action === "add") {
        var obj3 = _.cloneDeep(this.obj);
        //修改

        console.log(obj3, "obj3");

        this.dto.isApply = obj3.isApply;
      }
    },
  },
  methods: {
    selectAll(selection) {
      this.selectionList = selection;
    },
    judgeResourceTypeClassName(value) {
      return this.resourceTypeClassNameMap[value];
    },
    judgeResourceTypeText(value) {
      return CNST.ENUMS.resourceType[value];
    },

    flatChildrenOfRows(rows) {
      return rows.reduce((flattened, item) => {
        const { children } = item;
        return flattened.concat(
          [item],
          children && children.length > 0
            ? this.flatChildrenOfRows(children)
            : []
        );
      }, []);
    },
    flatParentsOfRows(row, flattenedTreeData) {
      const { parentId } = row;
      return parentId
        ? flattenedTreeData.reduce((acc, item) => {
            const { id } = item;
            return id === parentId
              ? acc.concat(
                  [item],
                  this.flatParentsOfRows(item, flattenedTreeData)
                )
              : acc.concat([]);
          }, [])
        : [row];
    },
    select(selection, row) {
      // 判断当前操作是勾选还是取消勾选
      const selected = this.$refs.umyTable
        .getCheckboxRecords()
        .some((item) => item === row);
      // 勾选父节点时，会勾选其全部子节点；取消勾选父节点时，会取消勾选其全部子节点
      // 将父节点及其子节点的数组拍平以便整体勾选及取消勾选
      const flattenedChildren = this.flatChildrenOfRows([row]);
      this.$refs.umyTable.partRowSelections(flattenedChildren, selected);
      // 勾选子节点时，会勾选其父节点；取消勾选子节点时，不会影响其父节点
      if (selected) {
        const treeData = this.$refs.umyTable.getUTreeData();
        const flattenedTreeData = this.flatChildrenOfRows(treeData);
        const flattenedParents = this.flatParentsOfRows(row, flattenedTreeData);
        this.$refs.umyTable.partRowSelections(flattenedParents, selected);
      }
      // 保存当前勾选节点
      this.selectionList = this.$refs.umyTable.getCheckboxRecords();
    },
    // 展开收起虚拟表格时候勾选已选节点
    toggleTreeExpand(row, treeExpanded, event) {
      this.$refs.umyTable.partRowSelections(this.selectionList, true);
    },
    //点击确认的事件
    handelClick() {
      this.submitLoading = true;
      // 获取虚拟列表中勾选行ID
      let allArrTree = this.selectionList.map((item) => item.id);
      console.log(allArrTree);
      //还要判断是否通过验证
      if (!this.$refs.form) {
        this.submitLoading = false;
        return;
      }
      this.$refs.form.validate((valid) => {
        if (!valid) {
          this.submitLoading = false;
          return;
        } else {
          this.dto.appId = this.query.appId;
          this.dto.appCode = this.query.appCode;
          this.dto.tenementCode = this.tenementInfoObj.tenementCode;
          // this.dto.isApply=parseInt( this.dto.isApply);
          //发请求 判断是否重名
          if (this.action == "edit") {
            api.rolePermissions
              .updateCommit({
                data: {
                  id: this.roleListId,
                  ...this.dto,
                  resourceIds: allArrTree,
                },
              })
              .then(async ({ code, data, msg }) => {
                if (code == 200) {
                  await this.queryList();
                  await this.updateVis();
                  await this.queryList();
                  this.submitLoading = false;
                  return this.$message.success(msg);
                } else if (code === 301) {
                  this.warningMessageVisible = true;
                  let warningSeconds = 5;
                  const message = `<p>${$t('language.5o6lhuk4phl0')},<span class="warning-message__seconds">${warningSeconds}</span>${$t('language.5o6uhukiphl0')}</p>`;
                  const duration = 0;
                  const dangerouslyUseHTMLString = true;
                  const customClass = "warning-message";
                  this.$message.warning({
                    message,
                    duration,
                    dangerouslyUseHTMLString,
                    customClass,
                  });
                  const step = () => {
                    setTimeout(() => {
                      if (this.warningMessageVisible && warningSeconds > 0) {
                        warningSeconds -= 1;
                        document.querySelector(
                          `.${customClass} .warning-message__seconds`
                        ).textContent = warningSeconds;
                        step();
                      } else {
                        this.updateVis(false);
                        this.submitLoading = false;
                      }
                    }, 1000);
                  };
                  step();
                } else {
                  this.ids = [3466, 3467, 3468];
                  this.submitLoading = false;
                  return this.$message.error(msg);
                }
              });
          } else if (this.action == "add") {
            api.rolePermissions
              .isHasUser({
                data: {
                  appCode: this.dto.appCode,
                  roleCode: this.dto.roleCode,
                  roleName: this.dto.roleName,
                  tenementCode: this.tenementInfoObj.tenementCode,
                },
              })
              .then(({ code, data, msg }) => {
                if (code == 200) {
                  //不重名
                  if (!data) {
                    if (this.action == "add") {
                      //这里发送天机角色的请求
                      api.rolePermissions
                        .roleAdd({
                          data: { ...this.dto, resourceIds: allArrTree },
                        })
                        .then(async ({ code, data, msg }) => {
                          if (code == 200) {
                            await this.queryList();
                            await this.updateVis();
                            this.submitLoading = false;
                            return this.$message.success(msg);
                          } else if (code !== 200) {
                            this.submitLoading = false;
                            return this.$message.error(msg);
                          }
                        });
                    } else if (this.action == "edit") {
                      this.submitLoading = false;
                    } else if (this.action == "view") {
                      this.submitLoading = false;
                    } else {
                      this.submitLoading = false;
                    }
                    //重名
                  } else {
                    this.submitLoading = false;
                    return this.$message.error($t('language.5o6vg67foso0'));
                  }
                } else {
                  this.submitLoading = false;
                }
              });
          } else {
            this.submitLoading = false;
          }
        }
      });
    },
    handleClose() {
      this.warningMessageVisible = false;
      this.$message.closeAll();
      this.submitLoading = false;
      // 清空虚拟列表选项
      this.$refs.umyTable.partRowSelections([], true);
      this.updateVis(false);
    },
  },
  beforeCreate() {
    this.allFields = [
      "roleName",
      "roleCode",
      "remark",
      "ext1",
      "ext2",
      "ext3",
      "ext4",
      "ext5",
      "ext6",
      "ext7",
      "ext8",
      "ext9",
      "ext10",
      "sensitiveMark",
      "flowId",
      "isApply",
      "illustration",
    ];
    this.disFields = [];
  },
  created() {
    this.dto.appCode = this.query.appCode;
    this.dto.tenementCode = this.tenementInfoObj.tenementCode;

    //  if(this.dto.tenementCode==='business-seller'  || this.dto.tenementCode==='DJQXXT'){this.checkIs=true}else{this.checkIs=false}
  },
  mounted() {
    //由于三个组件通用 上来添加的默认就是这个名字
    this.titleName = this.buttonData("tjcdjs").name;
  },
};
</script>

<style lang="scss" scoped>
/deep/ .tree--btn-wrapper {
  color: #666 !important;
  i {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 12px;
  }
}
.left {
  overflow: scroll;
  min-height: 50px;
  max-height: 400px;
}
.footer {
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.header1 {
  /*border: #63bc6f 1px solid;*/
  /*background-color:#ffcc00;*/
  /*display:-moz-inline-box;*/
  display: inline-block;
  width: 250px;
  text-align: center;
}

.header2 {
  /*border: #63bc6f 1px solid;*/
  /*background-color:#ffcc00;*/
  /*display:-moz-inline-box;*/
  display: inline-block;
  width: 370px;
  text-align: center;
}

.header3 {
  /*border: #63bc6f 1px solid;*/
  /*background-color:#ffcc00;*/
  /*display:-moz-inline-box;*/
  display: inline-block;
  width: 140px;
  text-align: center;
}

.header4 {
  /*border: #63bc6f 1px solid;*/
  /*background-color:#ffcc00;*/
  /*display:-moz-inline-box;*/
  display: inline-block;
  width: 60px;
  text-align: center;
}

.el-tree /deep/ .custom-tree-node {
  flex: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.el-tree /deep/ .custom-tree-node .span1 {
  overflow: hidden;
  /*border: #63bc6f 1px solid;*/
  /*background-color:#ffcc00;*/
  display: -moz-inline-box;
  display: inline-block;
  width: 400px;
}

.el-tree /deep/ .custom-tree-node .span2 {
  /*border: #63bc6f 1px solid;*/
  /*background-color:#ffcc00;*/
  display: -moz-inline-box;
  display: inline-block;
  width: 300px;
  position: absolute;
  left: 400px;
  overflow: hidden;
  text-align: left;
}
.el-tree /deep/ .custom-tree-node .span3 {
  /*border: #63bc6f 1px solid;*/
  /*background-color:#ffcc00;*/
  display: -moz-inline-box;
  display: inline-block;
  position: absolute;
  width: 100px;
  left: 650px;
  overflow: hidden;
  text-align: center;
  /*color: #67C23A;*/
}

.el-tree /deep/ .custom-tree-node .span3_1 {
  /*border: #63bc6f 1px solid;*/
  /*background-color:#ffcc00;*/
  display: -moz-inline-box;
  display: inline-block;
  position: absolute;
  width: 100px;
  left: 650px;
  overflow: hidden;
  text-align: center;
  /*color: #E6A23C;*/
}

.el-tree /deep/ .custom-tree-node .span4 {
  /*border: #63bc6f 1px solid;*/
  /*background-color:#ffcc00;*/
  display: -moz-inline-box;
  display: inline-block;
  position: absolute;
  width: 70px;
  left: 750px;
  overflow: hidden;
  text-align: center;
}

.el-tree /deep/ .custom-tree-node .span5 {
  /*border: #63bc6f 1px solid;*/
  /*background-color:#ffcc00;*/
  display: -moz-inline-box;
  display: inline-block;
  position: absolute;
  width: 70px;
  left: 580px;
  overflow: hidden;
  text-align: center;
  color: red;
}
</style>
